<template>
    <rkm-overlay>
        <rkm-layout-body title="Cadastro individual">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="print()"
                >
                    Imprimir termo de recusa
                </rkm-button>

                <rkm-button
                    @click="printFicha()"
                    color="info"
                >
                    Imprimir ficha
                </rkm-button>

                <rkm-button
                    v-if="hasPermissaoAtualizacaoCadastroPaciente"
                    @click="handleBuscarDadosPacienteIntegracaoCns"
                    color="info"
                >
                    Buscar dados do paciente no CADSUS
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    @handleCadastro="handleCadastro"
                    @handleExitSupervisor="handleExitSupervisor"
                    @loaded="loaded"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>

            <ModalIntegracaoCns
                @update="handleIntegracaoCnsUpdate"
                ref="ModalIntegracaoCns"
            />
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import Form from "@/components/atencao-basica/cadastro-individual/Form";
import ModalIntegracaoCns from '@/components/integracao/cns/components/busca//Modal'

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'

// Vuex.
import { mapActions } from 'vuex';

// Mixins
import { repository, error, object, data, unmask } from '@/mixins'

export default {
    components: {
        Form,
        ModalIntegracaoCns,
    },
    computed: {
        hasPermissaoAtualizacaoCadastroPaciente() {
            let hasPermissao = false

            if (this.additionals && this.additionals.permissoesAtualizacaoCadastroPaciente) {
                if (this.model && this.model.cidadao.classificacaoId === this.enums.classificacao.MUNICIPE && this.additionals.permissoesAtualizacaoCadastroPaciente.municipe) {
                    hasPermissao = true
                }
                else if (this.model && this.model.cidadao.classificacaoId === this.enums.classificacao.PROVISORIO && this.additionals.permissoesAtualizacaoCadastroPaciente.provisorio) {
                    hasPermissao = true
                }
                else if (this.model && this.model.cidadao.classificacaoId === this.enums.classificacao.OUTRO_MUNICIPIO && this.additionals.permissoesAtualizacaoCadastroPaciente.outroMunicipio) {
                    hasPermissao = true
                }
            }

            return hasPermissao
        },
    },
    created() {

        this.setShowExitFormConfirmation()

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.atencaoBasica')
        }
    },
    data: () => ({
        additionals: null,
        cadastro: false,
        enums: {classificacao},
        model: null,
    }),
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation',
            'setLoading',
            'unsetLoading'
        ]),
        loaded(value) {
            this.additionals = value.additionals
            this.model = value.model
        },
        handleExit() {
            this.$router.push({ name: 'atencao-basica-cadastro-individual' })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.handleExit()
        },
        handleExitSupervisor() {
            this.unsetShowExitFormConfirmation()
            this.handleExit()
        },
        print() {

            this.setLoading()

            this.repositories.impressao.termoRecusaCadastro(this.id)
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
        },
        printFicha() {

            if (this.cadastro) {

                this.setLoading()

                this.repositories.impressao.ficha(this.id)
                    .then(response => {

                        const content = new Blob([response.data], {type: response.headers['content-type']})
                        const url = URL.createObjectURL(content)
                        const link = document.createElement('a')

                        link.href = url
                        link.target = '_blank'
                        link.click()
                        link.remove()
                    })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
            } else {

                this.showAlert('É necessário preencher e salvar o cadastro individual para imprimir a ficha.', 'Atenção')
            }
        },
        handleCadastro() {

            this.cadastro = true
        },
        handleBuscarDadosPacienteIntegracaoCns() {
            const params = {
                id: this.model.cidadao.cidadaoId,
                nome: this.model.cidadao.nome,
                dataNascimento: this.model.cidadao.dataNascimento,
                nomeMae: this.model.cidadao.nomeMae,
                cns: this.model.cidadao.cns ? this.unMaskCns(this.model.cidadao.cns) : null,
                cpf: this.model.cidadao.cpf ? this.unMaskCpf(this.model.cidadao.cpf) : null,
            }

            this.$refs.ModalIntegracaoCns.open(params)
        },
        handleIntegracaoCnsUpdate(item) {
            Object.assign(this.model.cidadao, {
                ...item,
                sexoId: item.sexo.id,
            })
        },
    },
    mixins: [repository, error, object, data, unmask],
    props: {
        id: { type: Number, default: null }
    }
}
</script>